import {
  PagePermission,
  TabPermission,
} from 'src/app/core/interfaces/permissions';
import { PermissionsC } from 'src/permissions/helpers/permissions.class';
import { BrandSettings } from '../../brand-settings.setup';
import { BrandSettingsNotificationsAutomaticTab, BrandSettingsNotificationsManualTab } from './tabs';

const parent = BrandSettings.pages.notifications;
const title = 'PAGE.BRAND_SETTINGS.NOTIFICATIONS.TITLE';
const tabs: TabPermission[] = [
  BrandSettingsNotificationsAutomaticTab,
  BrandSettingsNotificationsManualTab,
];

export const BrandSettingsNotificationsPage: PagePermission =
  PermissionsC.generatePagePermission(parent, title, tabs);
